import React from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useI18n } from "../contexts/I18nContext";

const CONTENT = {
  terms: {
    el: {
      title: "Όροι Χρήσης",
      body: `Η υπηρεσία Dikigoros.io παρέχεται ως εργαλείο νομικής έρευνας. Το περιεχόμενο που παράγεται είναι προς αναθεώρηση από πιστοποιημένο δικηγόρο και δεν συνιστά νομική συμβουλή.`,
    },
    en: {
      title: "Terms of Service",
      body: `Dikigoros.io is provided as a legal research tool. Generated content is intended for review by a qualified advocate and does not constitute legal advice.`,
    },
  },
  privacy: {
    el: {
      title: "Πολιτική Απορρήτου",
      body: `Σεβόμαστε το απόρρητο σας. Τα έγγραφά σας αποθηκεύονται ιδιωτικά και δεν κοινοποιούνται σε τρίτους. Για ερωτήματα: privacy@dikigoros.io.`,
    },
    en: {
      title: "Privacy Policy",
      body: `We respect your privacy. Your documents are stored privately and not shared with third parties. Questions: privacy@dikigoros.io.`,
    },
  },
};

export default function LegalPage() {
  const { doc } = useParams();
  const { lang } = useI18n();
  const c = CONTENT[doc] || CONTENT.terms;
  const t = c[lang] || c.en;

  return (
    <>
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-20">
        <div className="kicker">Dikigoros.io</div>
        <h1 className="mt-3 font-display font-bold text-4xl text-slate-900">{t.title}</h1>
        <p className="mt-6 text-slate-700 leading-relaxed whitespace-pre-wrap">{t.body}</p>
      </main>
      <Footer />
    </>
  );
}
